export default __webpack_public_path__ + "static/media/chat_logo_healthgenom.384aa3c0.svg";